import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import AuthenticationLayout from './layout/AuthenticationLayout';

export default function NotFound404() {
    const { route } = useAuthenticator((context) => [context.route]);
    const isAuthenticated = route === 'authenticated';

    return (
        <AuthenticationLayout>
            <h1>Oops! You seem to be lost.</h1>
            <p>Here are some helpful links:</p>
            {isAuthenticated ? (
                <Link to="/dashboard/default">Dashboard</Link>
            ) : (
                <>
                    <Link to="/">Home</Link> <Link to="/login">Sign In</Link>
                </>
            )}
        </AuthenticationLayout>
    );
}
